<cam-loader [isLoading]="this.changeLanguageAsked()">
  <div class="mx-space-sm language-panel">
    <cam-list-container>
      @for (language of this.languages; track language.id) {
        <cam-list-element [withSeparator]="false" (click)="this.changeLanguage(language.id)">
          <cam-list-title class="d-flex p-space-xs">
            {{ language.name | translate }}
          </cam-list-title>
          @if (language.id === this.activeLanguage()) {
            <cam-list-tag>
              <cam-font-icon name="check-line" type="lg" class="color-semantic-token-success"></cam-font-icon>
            </cam-list-tag>
          }
        </cam-list-element>
      }
    </cam-list-container>
  </div>
</cam-loader>
